export default __webpack_public_path__ + "db829620fd8dc1e88be5d63e0845e02c.svg";